import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const accountStatusesAdapter = getAdapter({ idFieldName: 'value' });

const accountStatusesSlice = createSlice({
  name: 'accountStatuses',
  initialState: accountStatusesAdapter.getInitialState(),
  reducers: {
    setAccountStatuses: (state, { payload: { accountStatuses } }) => {
      accountStatusesAdapter.setAll(state, accountStatuses);
    },
  },
});

const selectors = accountStatusesAdapter.getSelectors(({ accountStatuses }) => accountStatuses);

export const getAccountStatuses = (state) => selectors.selectAll(state);

export const {
  setAccountStatuses,
} = accountStatusesSlice.actions;

export default accountStatusesSlice.reducer;